export default __webpack_public_path__ + "assets/profile-img.348a19ca.jpg";